import { useMemo } from 'react';
import { useAuth } from '../../contexts/useAuth';
import DashboardHeader from './components/DashboardHeader';
import DashboardFooter from './components/DashboardFooter';
import AppCard from './components/AppCard';
import RadarHud from '../../components/RadarHud';

interface App {
  slug?: string;
  title: string;
  description: string;
  imageUrl: string;
  link: string;
  accessMessage?: string;
  accessMessageColor?: 'green' | 'red' | 'orange';
  disabled?: boolean;
  services?: string[];
  isPWA?: boolean;
  imagePosition?: string;
}

const apps: App[] = [
  {
    slug: 'direction',
    title: 'Direction',
    description: 'Pilotage global du service et tableaux de bord stratégiques',
    imageUrl: '/direction.jpg',
    link: 'https://direction.dtcentre.net',
    accessMessage: 'Accès soumis à autorisations',
    accessMessageColor: 'red' as const,
    services: ['Direction'],
    isPWA: true,
  },
  {
    slug: 'gop',
    title: 'Gestionnaire Opérationnel',
    description: 'Coordination des interventions et suivi des unités terrain',
    imageUrl: '/gop.jpg',
    link: 'https://gop.dtcentre.net/',
    accessMessage: 'Accès autorisé avec vos identifiants',
    services: ['Direction', 'CDS'],
    isPWA: true,
  },
  {
    slug: 'cal',
    title: 'Cellule Admin. et Logistique CAL',
    description: 'Gestion administrative, logistique et ressources matérielles',
    imageUrl: '/cal.jpg',
    link: 'https://cal.dtcentre.net/',
    accessMessage: 'Accès autorisé avec vos identifiants',
    services: ['Direction', 'CAL'],
    isPWA: true,
  },
  {
    slug: 'aas',
    title: 'Gestionnaire AAS',
    description: "Gestionnaire des Agents d'accueil et de surveillance",
    imageUrl: '/aas.png',
    link: 'https://aas.dtcentre.net',
    accessMessage: 'Accès autorisé avec vos identifiants',
    services: ['Direction', 'AAS'],
    isPWA: true,
  },
  {
    slug: 'formations',
    title: 'GESTIONNAIRE DE FORMATION',
    description: 'Gestionnaire de Formation AAS et PM',
    imageUrl: '/formation.png',
    link: 'https://gestionnaireformation.netlify.app',
    accessMessage: 'Accès autorisé avec vos identifiants',
    services: ['Direction', 'CAL'],
    isPWA: false,
  },
  {
    slug: 'crah',
    title: 'CRAH',
    description: "Compte rendu d'activités hebdomadaire",
    imageUrl: '/crah.png',
    link: 'https://crahdtcentre.netlify.app/',
    accessMessage: 'Accès Serveur Local DPMP',
    isPWA: false,
  },
  {
    slug: 'terrasses',
    title: 'PV Terrasses',
    description: 'Gestion des procès-verbaux des terrasses et occupations domaine public',
    imageUrl: '/pv_terrasses.jpg',
    link: 'https://terrasses.dtcentre.net/',
    accessMessage: 'Accès autorisé avec vos identifiants',
    services: ['Direction', 'CDS', 'CCO', 'PM'],
    isPWA: true,
  },
  {
    slug: 'maraude',
    title: 'Application Service de Médiation',
    description: 'Application de suivi d\'observation terrain',
    imageUrl: '/mediation.jpg',
    link: 'https://maraude.netlify.app',
    accessMessage: 'Accès autorisé Service de médiation avec vos accès',
    services: ['Médiation'],
    isPWA: true,
  },
  {
    slug: 'cri',
    title: 'CRI Compte Rendu Interne',
    description: 'Rédaction et transmission des comptes rendus internes sécurisés',
    imageUrl: '/cri.jpg',
    link: 'https://cridtcentre.netlify.app',
    accessMessage: 'Accès autorisé avec vos identifiants',
    services: ['Direction', 'CDS'],
    isPWA: true,
  },
  {
    slug: 'outilsmanager',
    title: 'Gestionnaire de Documents',
    description: 'Archivage, classement et consultation des documents officiels',
    imageUrl: '/doc.jpg',
    link: 'https://docmanager.dtcentre.net/',
    accessMessage: 'Accès autorisé avec vos identifiants',
    services: ['Direction', 'CDS', 'PM', 'AAS'],
    isPWA: true,
  },
  {
    slug: 'pvmanagersiret',
    title: 'SIRET DE L\'API PARIS',
    description: 'SIRET De l\'API de la Ville de Paris',
    imageUrl: '/siretdataparis.jpg',
    link: 'https://terrasses.netlify.app',
    accessMessage: 'Accès libre',
    services: ['Direction', 'CDS', 'PM'],
    isPWA: false,
  },
  {
    slug: 'etablissementspvmanager',
    title: 'ÉTABLISSEMENTS DU PVMANAGER',
    description: 'Liste des établissements qui ont déjà fait l\'objet d\'une verbalisation dans le PVMANAGER',
    imageUrl: '/pvmanagersiret.jpg',
    link: 'https://siretdtcentre.netlify.app',
    accessMessage: 'Accès libre',
    services: ['Direction', 'CDS', 'PM'],
    isPWA: false,
  },
  {
    slug: 'affichages',
    title: 'Affichages Sauvages et Dépôts',
    description: 'Signalement et suivi des affichages illégaux et dépôts sauvages',
    imageUrl: '/affichages.jpg',
    link: 'https://affichages.dtcentre.net',
    accessMessage: 'Accès autorisé avec vos identifiants',
    services: ['Direction', 'CDS', 'PM', 'AAS'],
    isPWA: true,
  },
  {
    slug: 'conseildequartier',
    title: 'Carte Conseils de Quartiers',
    description: 'Cartographie interactive des conseils et secteurs de quartiers',
    imageUrl: '/conseils.jpg',
    link: 'https://conseildequartier.netlify.app',
    accessMessage: 'Accès autorisé avec vos identifiants',
    services: ['Direction', 'CDS', 'CCO', 'PM', 'AAS'],
    isPWA: true,
  },
  {
    slug: 'chantale',
    title: 'Tableau Suivi Stagiaire',
    description: 'Gestion des parcours de stage, évaluations et planning des stagiaires',
    imageUrl: '/stagiaire.jpg',
    link: 'https://chantale.dtcentre.net',
    accessMessage: 'Accès autorisé avec vos identifiants',
    services: ['CDS', 'CAL'],
    isPWA: true,
  },
  {
    slug: 'elmepm',
    title: 'Main Courante ELM EPM',
    description: 'Registre quotidien des interventions des équipes de médiation ELM et EPM',
    imageUrl: '/elmepm.jpg',
    link: 'https://elmepm.dtcentre.net',
    accessMessage: 'Accès autorisé avec vos identifiants',
    services: ['Direction', 'CDS', 'ELM', 'EPM'],
    isPWA: false,
  },
  {
    slug: 'hs',
    title: 'Calcule des HS',
    description: 'Calcul et gestion des heures supplémentaires du personnel',
    imageUrl: '/hs.jpg',
    link: 'https://hsdtcentre.netlify.app',
    accessMessage: 'Accès libre à tous',
    services: ['Toute la DT'],
    isPWA: false,
  },
  {
    slug: 'chefdebrigade',
    title: 'Chef de Brigade',
    description: 'Outil pour gérer les planning des agents',
    imageUrl: '/brigades.jpg',
    link: 'https://chefdebrigade.netlify.app',
    accessMessage: 'Application en accès libre',
    services: ['Chef(fe) de brigade'],
    isPWA: false,
  },
  {
    slug: 'parisdata',
    title: 'PARIS DATA',
    description: 'Données API de la ville de Paris',
    imageUrl: '/parisdata.jpg',
    link: 'https://parisdata.netlify.app',
    accessMessage: 'Accès autorisé avec vos identifiants',
    services: ['Direction', 'CDS', 'PM'],
    isPWA: true,
  },
  {
    slug: 'jardinsparis',
    title: 'Calcul itinéraires',
    description: 'Calcul et optimisation des itinéraires de patrouille',
    imageUrl: '/carte.jpg',
    link: 'https://jardinsparis.netlify.app',
    accessMessage: 'Accès autorisé avec vos identifiants',
    services: ['Direction', 'CDS'],
    isPWA: false,
  },
];

export default function Home() {
  const { authorizedApps, loading, favorites, toggleFavorite } = useAuth();

  const filteredApps = useMemo(
    () => (loading ? [] : apps.filter((app) => !app.slug || authorizedApps.includes(app.slug))),
    [loading, authorizedApps]
  );

  const renderAppCard = (app: App) => (
    <AppCard
      key={app.slug ?? app.title}
      title={app.title}
      description={app.description}
      imageUrl={app.imageUrl}
      link={app.link}
      accessMessage={app.accessMessage}
      accessMessageColor={app.accessMessageColor}
      disabled={app.disabled ?? false}
      services={app.services}
      isPWA={app.isPWA}
      isFavorite={!!app.slug && favorites.includes(app.slug)}
      onToggleFavorite={app.slug ? () => toggleFavorite(app.slug!) : undefined}
    />
  );

  // Favoris en tête de liste, pour qu'ils remontent dans les deux colonnes
  const sortedApps = useMemo(() => {
    const favApps = filteredApps.filter((app) => app.slug && favorites.includes(app.slug));
    const rest = filteredApps.filter((app) => !app.slug || !favorites.includes(app.slug));
    return [...favApps, ...rest];
  }, [filteredApps, favorites]);

  const leftApps = useMemo(() => sortedApps.filter((_, i) => i % 2 === 0), [sortedApps]);
  const rightApps = useMemo(() => sortedApps.filter((_, i) => i % 2 === 1), [sortedApps]);

  return (
    <div className="min-h-screen bg-hub-bg bg-police-lights font-sans overflow-x-hidden" style={{ fontFamily: "'Inter', system-ui, sans-serif" }}>
      <DashboardHeader />

      {/* Main content */}
      <main className="relative z-[1] pt-14 lg:pt-14 pb-9 min-h-screen">
        {/* Titre (mobile/tablet uniquement, sur desktop le titre est dans le header) */}
        <div className="text-center px-4 pt-[5px] mb-8 lg:hidden">
          <h1 className="text-hub-text font-bold text-xl tracking-widest uppercase drop-shadow-[0_0_12px_rgba(59,130,246,0.7)]">
            HUB DT CENTRE
          </h1>
        </div>

        {/* Layout 5 colonnes sur desktop : 2 + radar + 2 */}
        <div className="hidden lg:flex px-4 lg:px-6 gap-4 items-start">
          {/* Colonne gauche : 2 colonnes d'apps */}
          <div className="flex-1 grid grid-cols-2 gap-4 content-start">
            {leftApps.map(renderAppCard)}
          </div>

          {/* Colonne centrale : réserve l'espace, radar + HUD fixes au centre */}
          <div className="w-[260px] shrink-0 hidden lg:block">
            <RadarHud />
          </div>

          {/* Colonne droite : 2 colonnes d'apps */}
          <div className="flex-1 grid grid-cols-2 gap-4 content-start">
            {rightApps.map(renderAppCard)}
          </div>
        </div>

        {/* Layout mobile : apps en dessous du radar */}
        <div className="lg:hidden px-4 space-y-4">
          {sortedApps.map(renderAppCard)}
        </div>
      </main>

      <DashboardFooter />
    </div>
  );
}